import { toast } from 'react-toastify';
import { RCardGet, cardUpdate } from '../../../../../../../apiRPC/card';
import { dynamicObjectCreate } from '../../../../../../../apiRPC/dynamicObject';
import {
  AdditionalFieldsModel,
  buildUnifiedDynamicObjectDefinition,
} from '../model';

type UseAccordionDynamicObjectParams = {
  card: RCardGet;
  values: AdditionalFieldsModel;
  mainDynamicObjectId: string | null;
  isDynamicObjectCreating: boolean;
  setIsAdditionalFieldsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDynamicObjectCreating: React.Dispatch<React.SetStateAction<boolean>>;
  setMainDynamicObjectId: React.Dispatch<React.SetStateAction<string | null>>;
};

type UseAccordionDynamicObjectResult = {
  handleAccordionChange: (
    event: React.SyntheticEvent,
    expanded: boolean,
  ) => void;
};

export function useAccordionDynamicObject({
  card,
  values,
  mainDynamicObjectId,
  isDynamicObjectCreating,
  setIsAdditionalFieldsExpanded,
  setIsDynamicObjectCreating,
  setMainDynamicObjectId,
}: UseAccordionDynamicObjectParams): UseAccordionDynamicObjectResult {
  const handleAccordionChange = (
    _: React.SyntheticEvent,
    expanded: boolean,
  ) => {
    setIsAdditionalFieldsExpanded(expanded);

    if (!expanded || mainDynamicObjectId || isDynamicObjectCreating) {
      return;
    }

    setIsDynamicObjectCreating(true);

    const unifiedDefinition = buildUnifiedDynamicObjectDefinition(values);

    dynamicObjectCreate({
      fields: { object: unifiedDefinition },
    })
      .then(async (created) => {
        await cardUpdate({
          uuid: card.uuid,
          fields: { dynamicObjects: { add: [created.id] } },
        });
        setMainDynamicObjectId(created.id);
      })
      .catch((error) => {
        console.error(error);
        toast.error('Ошибка при создании дополнительных полей', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      })
      .finally(() => {
        setIsDynamicObjectCreating(false);
      });
  };

  return { handleAccordionChange };
}
